exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TapSelector-module__container--1LkyU {\r\n  width: 100%;\r\n  height: 56px;\r\n  display: flex;\r\n}\r\n\r\n.TapSelector-module__tap--1zrRi {\r\n  display: flex;\r\n  flex: 1;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 16px;\r\n  color: #888888;\r\n  cursor: pointer;\r\n}\r\n\r\n.TapSelector-module__selected--3U_yP {\r\n  font-weight: bold;\r\n  color: #ff7d40;\r\n  border-bottom: 4px solid #ff7d40;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "TapSelector-module__container--1LkyU",
	"tap": "TapSelector-module__tap--1zrRi",
	"selected": "TapSelector-module__selected--3U_yP"
};